module.exports = "### Layout\r\n\r\n- Use a picker to quickly search for a few tags or files.\r\n- Use a picker to manage a group of tags or files.\r\n"